import { render } from "./Navgater.vue?vue&type=template&id=779fc62c&scoped=true&ts=true"
import script from "./Navgater.vue?vue&type=script&lang=ts"
export * from "./Navgater.vue?vue&type=script&lang=ts"

import "./Navgater.vue?vue&type=style&index=0&id=779fc62c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779fc62c"]])

export default __exports__